import { render } from "./battery.vue?vue&type=template&id=ad2cf4ac&scoped=true"
import script from "./battery.vue?vue&type=script&lang=js"
export * from "./battery.vue?vue&type=script&lang=js"

import "./battery.vue?vue&type=style&index=0&id=ad2cf4ac&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad2cf4ac"]])

export default __exports__